export default __webpack_public_path__ + "static/media/banner-3-new.2807767b.jpg";